module.exports = __webpack_public_path__ + "static/media/Ford.6c98156f.png";